import { type FC, type ReactNode } from "react";
import { ApplicationInsightsProvider } from "@packsize/application-monitoring";

import { applicationInsightsConnectionString, applicationName, applicationVersion } from "@/environment";

export const AppInsightsProvider: FC<{ readonly children: ReactNode }> = ({ children }) => {
	return (
		<ApplicationInsightsProvider
			connectionString={applicationInsightsConnectionString}
			applicationName={applicationName}
			applicationVersion={applicationVersion}
		>
			{children}
		</ApplicationInsightsProvider>
	);
};
